import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import Utils from "../../utils";
import { getVehiclePartList } from "../../services/VehicleService";
import EditInternalIdButton from "../../components/EditInternalIdButton";
import { Form, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import {
  AddReservesSendPart,
  createReplicatePart,
  deletePartInventoryHard,
  downloadPartImageZip,
  getPartInventoryDetails,
  getPartVideoSortDetails,
  getReservesPartPendingList,
  getwarHouseEntityList,
  partInvenoryPartDelete,
  PartInventoryImageDetails,
  ReservesSerachData,
  updatePartInternalId,
} from "../../services/PartsInventory";
import { useTranslation } from "react-i18next";
import { tConst } from "../../utils/constantsTranslator";
import ReactStars from "react-rating-stars-component";
import Select from "react-select";
import ConfigDB from "../../config";
import { PhotoProvider, PhotoView } from "react-photo-view";

const PartdetailsInventory = () => {
  const state = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { uuid } = useParams();
  const tableLengthList = ConfigDB.data.dataTableLength;
  const data = localStorage.getItem(ConfigDB.data.login_data);
  const companyId = JSON.parse(data);

  const [params, setParams] = useState({
    limit: tableLengthList[0],
    page: 1,
    search: "",
    is_reload: false,
    company_id: companyId.company_id || 0,
  });

  const [vehiclePartDetails, setVehiclePartDetails] = useState("");
  const [delModal, setDelModal] = useState(false);
  const [delpart, setDelPart] = useState("");
  const [vehicleImageDetails, setVehicleImageDetails] = useState([]);
  const [vehicleVideoDetails, setVehicleVideoDetails] = useState([]);
  const [modifyReplicateParts, setModifyReplicateParts] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [PartsDataList, setPartsDataList] = useState("");
  const [reservesPenList, setReservesPenList] = useState([]);

  const [replicatePartsData, setReplicatePartsData] = useState({
    copy_photo: 0,
    copy_video: 0,
    copy_reference: 0,
    copy_damage: 0,
    copy_compatiable_vehicles: 0,
  });

  const [partAddDetails, setPartAddDetails] = useState("");
  const [loading, setLoading] = useState(false);
  const [modifyVehiclereplica, setModifyVehiclereplica] = useState(false);
  const [modifyReservesParts, setModifyReservesParts] = useState(false);
  const [reservesSerachList, setReservesSerachList] = useState([]);
  const [reservesData, setReservesData] = useState({
    reservation_id: "",
  });

  const [selectedPrices, setSelectedPrices] = useState({});

  const [selectedParts, setSelectedParts] = useState([]);
  const [resOrderData, setResOrderData] = useState({
    reservation_order_notes: "",
  });
  const [selectedEntitiesRes, setSelectedEntitiesRes] = useState({});
  const [entityList, setEntityList] = useState([]);
  const [partAttributesList, setPartAttributesList] = useState([]);
  const [delRestoreModa, setDelRestoreModal] = useState(false);
  const [delPartRestoreId, setDelPartRestoreId] = useState("");
  const [isDelButtonLoad, setIsDelButtonLoad] = useState(false);
  const [viewerOpen, setViewerOpen] = useState(false);
  const [viewerIndex, setViewerIndex] = useState(0);

  const getFieldPermission = (attribute_name) => {
    if (partAttributesList?.attribute_array?.length === 0) {
      return { show: true, editable: true };
    }

    const attr = partAttributesList?.attribute_array?.find(
      (item) => item.column_name === attribute_name
    );

    if (!attr) {
      return { show: false, editable: false };
    }

    return {
      show: attr.is_view === 1,
      editable: attr.is_edit === 1,
    };
  };

  // Flags booleanas vindas do PG podem chegar como true/1/"1"/"true".
  const isFlagOn = (value) =>
    value === true || value === 1 || value === "1" || value === "true";

  const handleSelectChangeRes = (event, item) => {
    const value = event.target.value;

    setSelectedEntitiesRes((prevState) => ({
      ...prevState,
      [item.id]: value,
    }));
  };

  const handleManualInput = (partId, value) => {
    setSelectedPrices((prev) => ({
      ...prev,
      [partId]: value,
    }));
  };

  const handleCheckboxChange = (partId, id) => {
    setSelectedParts((prev) => {
      const isAlreadySelected = prev.some((item) => item.id === id);

      if (isAlreadySelected) {
        return prev.filter((item) => item.id !== id);
      } else {
        return [...prev, { parts_id: partId, id }];
      }
    });
  };

  const renderOptions = (nodes, level = 0) => {
    return nodes?.map((node) => {
      if (node.children && node.children.length > 0) {
        return (
          <>
            <optgroup
              label={"\u00A0\u00A0".repeat(level) + node.warehouse_name}
              key={node.id}
            />
            {renderOptions(node.children, level + 1)}
          </>
        );
      } else {
        return (
          <option value={node.id} key={node.id}>
            {"\u00A0\u00A0".repeat(level) + node.warehouse_name}
          </option>
        );
      }
    });
  };

  useEffect(() => {
    if (reservesData?.reservation_id) {
      let data = {
        parts_id: [uuid],
        reservation_id: reservesData?.reservation_id
          ? reservesData?.reservation_id
          : "",
        limit: tableLengthList[0],
        page: 1,
        search: "",
        is_reload: false,
        company_id: companyId.company_id || 0,
        is_update: false,
      };
      getReservesPartPendingList(data)
        .then((response) => {
          setReservesPenList(response.data.data);
        })
        .catch((err) => {
          toast.dismiss();
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [reservesData?.reservation_id]);

  useEffect(() => {
    if (Array.isArray(reservesPenList) && reservesData?.reservation_id) {
      const matchingParts = reservesPenList.find((item) =>
        item.reserve_order_list?.some(
          (r) =>
            Number(r.reservation_id) === Number(reservesData?.reservation_id)
        )
      );

      if (matchingParts) {
        // Extract and map based on reservation_id
        const preSelectedParts = [];
        const preSelectedPrices = {};
        const preSelectedEntities = {};
        const preReservationNotes = {};

        matchingParts.reserve_order_list.forEach((reserve) => {
          if (
            Number(reserve.reservation_id) !==
            Number(reservesData?.reservation_id)
          )
            return;

          const matchedPart = matchingParts.part_qty_list.find(
            (p) => Number(p.id) === Number(reserve.part_qty_label_id)
          );

          if (matchedPart) {
            preSelectedParts.push(matchedPart);
            preSelectedPrices[matchedPart.id] = reserve.reserve_price;

            preSelectedEntities[matchedPart.id] = reserve.location_id;
            preReservationNotes[matchedPart.id] =
              reserve.reservation_order_notes || "";
          }
        });

        setSelectedParts(preSelectedParts);
        setSelectedPrices(preSelectedPrices);
        setSelectedEntitiesRes(preSelectedEntities);
        setResOrderData((prev) => ({
          ...prev,
          reservation_order_notes: preReservationNotes,
        }));
      }
    }
  }, [reservesPenList, reservesData]);

  useEffect(() => {
    let data = { ...params };
    getwarHouseEntityList(data)
      .then((response) => {
        setEntityList(response.data.data);
      })
      .catch((err) => {
        toast.error(err.message);
      });
  }, [params]);

  useEffect(function () {
    let data = {
      limit: 10,
      page: params.page,
      search: "",
      is_reload: true,
    };
    ReservesSerachData(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i]?.id,
            label: response.data[i]?.reservation_name,
          });
        }
        setReservesSerachList(list);
      })
      .catch((err) => {});
  }, []);

  const handleReservesOpen = (e, item) => {
    setPartsDataList(item);
    setModifyReservesParts(true);
  };

  const handleReservesClose = () => {
    setModifyReservesParts(false);
    setSelectedParts([]);
    setReservesData({
      reservation_id: "",
    });
    setReservesPenList([]);
  };

  const handleReplicateOpen = () => {
    setModifyReplicateParts(true);
  };

  const handleReplicateClose = () => {
    setModifyReplicateParts(false);
    setReplicatePartsData({
      copy_photo: "",
      copy_video: "",
      copy_reference: "",
      copy_damage: "",
      copy_compatiable_vehicles: "",
    });
  };

  const handleVehiclereplicaOpen = () => {
    setModifyVehiclereplica(false);
    setModifyReplicateParts(false);
    setReplicatePartsData({
      copy_photo: "",
      copy_video: "",
      copy_reference: "",
      copy_damage: "",
      copy_compatiable_vehicles: "",
    });
  };

  const handleCheckboxChangeCompatibleVehicle = (e) => {
    setReplicatePartsData({
      ...replicatePartsData,
      copy_compatiable_vehicles: e.target.checked ? 1 : 0,
    });
  };

  const handleCheckboxChangeCopyPhoto = (e) => {
    setReplicatePartsData({
      ...replicatePartsData,
      copy_photo: e.target.checked ? 1 : 0,
    });
  };

  const handleCheckboxChangeCopyVideo = (e) => {
    setReplicatePartsData({
      ...replicatePartsData,
      copy_video: e.target.checked ? 1 : 0,
    });
  };

  const handleCheckboxChangeCopyRef = (e) => {
    setReplicatePartsData({
      ...replicatePartsData,
      copy_reference: e.target.checked ? 1 : 0,
    });
  };

  const handleCheckboxChangeCopyDamage = (e) => {
    setReplicatePartsData({
      ...replicatePartsData,
      copy_damage: e.target.checked ? 1 : 0,
    });
  };

  const handleSubmitReplicateParts = (e) => {
    e.preventDefault();
    const payload = {
      copy_photo: replicatePartsData?.copy_photo
        ? replicatePartsData?.copy_photo
        : 0,
      copy_video: replicatePartsData?.copy_video
        ? replicatePartsData?.copy_video
        : 0,
      copy_reference: replicatePartsData?.copy_reference
        ? replicatePartsData?.copy_reference
        : 0,
      copy_damage: replicatePartsData?.copy_damage
        ? replicatePartsData?.copy_damage
        : 0,
      copy_compatiable_vehicles: replicatePartsData?.copy_compatiable_vehicles
        ? replicatePartsData?.copy_compatiable_vehicles
        : 0,
      part_id: uuid,
    };

    if (partAddDetails?.vehicle_id) {
      setModifyVehiclereplica(true);
      setModifyReplicateParts(false);
    } else {
      createReplicatePart(payload)
        .then((response) => {
          toast.success(response.data.message);
          setModifyReplicateParts(false);
          setReplicatePartsData({
            copy_photo: "",
            copy_video: "",
            copy_reference: "",
            copy_damage: "",
            copy_compatiable_vehicles: "",
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          // Reset button state to "close"
          setLoading(false);
        });
    }
  };

  const handleSubmitVehicleReplicateParts = (e) => {
    e.preventDefault();

    const payload = {
      copy_photo: replicatePartsData?.copy_photo,
      copy_video: replicatePartsData?.copy_video,
      copy_reference: replicatePartsData?.copy_reference,
      copy_damage: replicatePartsData?.copy_damage,
      copy_compatiable_vehicles: replicatePartsData?.copy_compatiable_vehicles,
      part_id: uuid,
    };

    createReplicatePart(payload)
      .then((response) => {
        toast.success(response.data.message);
        setModifyReplicateParts(false);
        setModifyVehiclereplica(false);

        setReplicatePartsData({
          copy_photo: "",
          copy_video: "",
          copy_reference: "",
          copy_damage: "",
          copy_compatiable_vehicles: "",
        });
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        // Reset button state to "close"
        setLoading(false);
      });
  };

  const handleSubmitReserves = (e) => {
    e.preventDefault();

    if (!selectedParts.length > 0) {
      toast.error("at least one quntity assign");
      return;
    }

    const allPricesSelected = selectedParts.every(
      (item) =>
        selectedPrices[item.id] !== undefined &&
        selectedPrices[item.id] !== null
    );

    if (!allPricesSelected) {
      toast.error(t("pi_toast_invalid_price_all_parts"));
      return;
    }

    const partListData = [];

    selectedParts?.forEach((item) => {
      const partsId = item.parts_id;

      let partGroup = partListData.find((entry) => entry.parts_id === partsId);
      if (!partGroup) {
        partGroup = { parts_id: partsId, part_qty_list: [] };
        partListData.push(partGroup);
      }

      partGroup.part_qty_list.push({
        reserve_price: selectedPrices[item.id] ?? 0,
        reserve_vat_price: 0,
        part_qty_id: item.id,
        location_id: selectedEntitiesRes[item?.id],
        reservation_order_notes:
          resOrderData.reservation_order_notes[item.id] || "",
      });
    });

    let data = {
      part_list: partListData,
      part_id: PartsDataList?.id,
      reservation_id: reservesData?.reservation_id,
    };

    AddReservesSendPart(data)
      .then((response) => {
        toast.success(response.data.message);
        navigate("/show-reserves-list");
        setSelectedParts([]);
        setReservesData({
          reservation_id: "",
        });
        setReservesPenList([]);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  };

  useEffect(
    function () {
      if (uuid) {
        var obj = {
          id: uuid,
        };
        getPartInventoryDetails(obj)
          .then((response) => {
            setPartAddDetails(response.data.data);
            setPartAttributesList(response.data.data.part_inventory_attribute);
          })
          .catch((err) => {});
      }
    },

    []
  );

  useEffect(
    function () {
      if (uuid) {
        var obj = {
          id: uuid,
        };
        getPartVideoSortDetails(obj)
          .then((response) => {
            response = response.data.data;
            setVehicleVideoDetails(response);
          })
          .catch((err) => {});
      }
    },

    [uuid]
  );

  useEffect(
    function () {
      if (uuid) {
        var obj = {
          id: uuid,
        };
        PartInventoryImageDetails(obj)
          .then((response) => {
            response = response.data.data;
            setVehicleImageDetails(response);
          })
          .catch((err) => {});
      }
    },

    [uuid]
  );

  useEffect(() => {
    if (uuid) {
      let data = {
        vehicle_id: 0,
        part_id: uuid,
        record_show_type: 1,
      };

      getVehiclePartList(data)
        .then((response) => {
          setVehiclePartDetails(response.data.data);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [uuid]);

  const onDeleteModalOpen = (e, item) => {
    e.preventDefault();
    setDelPart(item.id);
    setDelModal(true);
  };

  const onDestroyPartType = (e) => {
    e.preventDefault();

    let data = { id: delpart, delete_type: 1 };
    partInvenoryPartDelete(data)
      .then((response) => {
        if (state?.state?.id) {
          let data = {
            vehicle_id: 0,
            part_id: state?.state?.id,
          };

          getVehiclePartList(data)
            .then((response) => {
              setVehiclePartDetails(response.data.data);
            })
            .catch((err) => {
              toast.error(Utils.getErrorMessage(err));
            });
        }
        toast.success(response.data.message);
        setDelPart("");
        setDelModal(false);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const onDestroyassociatePartType = (e) => {
    e.preventDefault();

    let data = { id: delpart, delete_type: 2 };
    partInvenoryPartDelete(data)
      .then((response) => {
        if (state?.state?.id) {
          let data = {
            vehicle_id: 0,
            part_id: state?.state?.id,
          };

          getVehiclePartList(data)
            .then((response) => {
              setVehiclePartDetails(response.data.data);
            })
            .catch((err) => {
              toast.error(Utils.getErrorMessage(err));
            });
        }
        toast.success(response.data.message);
        setDelPart("");
        setDelModal(false);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const onDeleteModalClose = () => {
    setDelModal(false);
  };
  const handleZipPartImageDownload = (e) => {
    e.preventDefault();
    setIsDownloading(true);

    let data = {
      vehicle_id: partAddDetails?.vehicle_id,
      part_id: uuid,
      is_images: 1,
    };

    downloadPartImageZip(data)
      .then((response) => {
        toast.success(response.data.message);

        const downloadUrl = response.data.downloadUrl;

        if (downloadUrl) {
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.download = downloadUrl.split("/").pop(); // Set the file name based on URL
          link.click();
        } else {
          toast.error(t("pi_toast_no_download_url"));
        }
      })
      // .then((response) => {
      //   setPartAddDetails(response.data.data);
      // })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        setIsDownloading(false); // Stop loader
      });
  };

  const handleZipPartVideoDownload = (e) => {
    e.preventDefault();

    setIsLoading(true); // Show the loader

    let data = {
      vehicle_id: partAddDetails?.vehicle_id,
      part_id: uuid,
      is_images: 0,
    };

    downloadPartImageZip(data)
      .then((response) => {
        setIsLoading(false); // Hide the loader after download is complete
        toast.success(response.data.message);

        const downloadUrl = response.data.downloadUrl;

        if (downloadUrl) {
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.download = downloadUrl.split("/").pop(); // Set the file name based on URL
          link.click();
        } else {
          toast.error(t("pi_toast_no_download_url"));
        }
      })
      .catch((err) => {
        setIsLoading(false); // Hide the loader if there's an error
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const onDeleteModalRestoreOpen = (e, item) => {
    e.preventDefault();
    setDelPartRestoreId(item);
    setDelRestoreModal(true);
  };

  const onDeleteRestoreModalClose = () => {
    setDelRestoreModal(false);
  };

  const onDestroyPartInventory = (e) => {
    e.preventDefault();
    setIsDelButtonLoad(true);

    const UpdateData = {
      record_show_type: 1,
      part_id: delPartRestoreId.id,
    };

    deletePartInventoryHard(UpdateData)
      .then((response) => {
        toast.success(response.data.message);

        setDelPartRestoreId(false);
        setIsDelButtonLoad(false);
        setDelRestoreModal(false);

        if (state?.state?.id) {
          const data = {
            vehicle_id: 0,
            part_id: state.state.id,
          };

          return getVehiclePartList(data)
            .then((res) => {
              setVehiclePartDetails(res.data.data);
            })
            .catch((err) => {
              toast.error(Utils.getErrorMessage(err));
            });
        }
      })
      .catch((err) => {
        setDelRestoreModal(false);
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        setIsDelButtonLoad(false);
      });
  };

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">{/* <h1>Vehicle</h1> */}</div>
              <div className="col-sm-6"></div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="container-fluid">
            <div className="card fuelCard">
              <div className="cardHeader card-header card-header-custom">
                <div className="row mb-2">
                  <div className="col-sm-6">
                    <p>Part Details</p>
                  </div>
                  <div className="col-sm-6">
                    <div className="d-flex  justify-content-end">
                      <button
                        type="button"
                        className="next-button btn btn-secondary"
                        onClick={() => {
                          if (state?.state?.history_id) {
                            navigate("/history-repairs-process");
                          } else if (state?.state?.part_management_type) {
                            navigate(`/vehicle/${state?.state?.uuid}`);
                          } else {
                            navigate("/parts-inventory");
                          }
                        }}
                      >
                        <i className="bi bi-arrow-left"></i> {t("back")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          {vehiclePartDetails?.parts?.length > 0 ? (
            vehiclePartDetails?.parts?.map((item, index) => {
              const publicPageUrl = `${window.location.origin}/part-details/${item.uuid}`;
              const mailto = `mailto:recipient@example.com?subject=Part Details Link&body=Here is the link to the part details:%0D%0A${publicPageUrl}`;
              const whatsappUrl = `https://wa.me/?text=Here is the link to the part details:%20${encodeURIComponent(
                publicPageUrl
              )}`;

              return (
                <>
                  <div className="container-fluid" key={index}>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="card fuelCard">
                          <div className="cardHeader card-header card-header-custom">
                            <div className="row">
                              <div className="col-md-4">
                                <p>
                                  Part Details
                                  {isFlagOn(
                                    item?.on_order ?? partAddDetails?.on_order
                                  ) && (
                                    <span
                                      className="badge ms-2"
                                      style={{
                                        backgroundColor: "#fd7e14",
                                        color: "#fff",
                                        verticalAlign: "middle",
                                      }}
                                    >
                                      {t("pi_on_order")}
                                    </span>
                                  )}
                                  {isFlagOn(
                                    item?.is_draft ?? partAddDetails?.is_draft
                                  ) && (
                                    <span
                                      className="badge ms-2"
                                      style={{
                                        backgroundColor: "#6f42c1",
                                        color: "#fff",
                                        verticalAlign: "middle",
                                      }}
                                    >
                                      {t("pi_draft")}
                                    </span>
                                  )}
                                </p>
                              </div>
                              <div className="col-md-8">
                                <div className="float-end">
                                  {item.deleted_at ? (
                                    <button
                                      style={{
                                        width: "140px",
                                        marginRight: "10px",
                                      }}
                                      type="button"
                                      className="btn bg-red ms-1 btn-filter"
                                      onClick={(e) =>
                                        onDeleteModalRestoreOpen(e, item)
                                      }
                                    >
                                      <span className="ms-1">Restore</span>
                                    </button>
                                  ) : (
                                    <button
                                      style={{
                                        width: "140px",
                                        marginRight: "10px",
                                      }}
                                      type="button"
                                      className="btn btn-primary ms-1 btn-filter"
                                      onClick={() => {
                                        navigate(
                                          `/parts-inventory/AddParts/${item.id}`
                                        );
                                      }}
                                    >
                                      <span className="ms-1">{t("edit")}</span>
                                    </button>
                                  )}

                                  <button
                                    style={{
                                      width: "140px",
                                      marginRight: "10px",
                                    }}
                                    type="button"
                                    className="btn  btn-primary ms-1 btn-filter"
                                    onClick={(e) => handleReservesOpen(e, item)}
                                  >
                                    <span className="ms-1 ">
                                      Reserves Parts
                                    </span>
                                  </button>

                                  <button
                                    style={{
                                      width: "140px",
                                      marginRight: "10px",
                                    }}
                                    type="button"
                                    className="btn  btn-primary ms-1 btn-filter"
                                    onClick={handleReplicateOpen}
                                  >
                                    <span className="ms-1 ">
                                      Replicate Parts
                                    </span>
                                  </button>

                                  <a href={mailto} className="btn btn-email">
                                    <i className="bi bi-envelope"></i>
                                  </a>

                                  <a
                                    href={whatsappUrl}
                                    className="btn btn-success btn-whats"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <i className="bi bi-whatsapp"></i>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="card-body card-body-custom">
                            <div className="row justify-content-start">
                              {getFieldPermission("part_name").show && (
                                <div className="col-sm-6">
                                  <div className="invoice-col">
                                    <b> Part Name:</b>{" "}
                                    <address>{item?.part_name}</address>
                                  </div>
                                </div>
                              )}
                              {getFieldPermission("parts_internal_id").show && (
                                <div className="col-sm-6">
                                  <div className="invoice-col">
                                    <b>{t("Internal Id")}:</b>{" "}
                                    <address style={{
                                      display: "inline-flex",
                                      alignItems: "center",
                                      gap: "4px",
                                      marginBottom: 0,
                                    }}>
                                      {item?.parts_internal_id}
                                      <EditInternalIdButton
                                        kind="part"
                                        uuid={item?.uuid}
                                        currentValue={item?.parts_internal_id}
                                        onUpdated={(newId) => {
                                          item.parts_internal_id = newId;
                                          setVehiclePartDetails({
                                            ...vehiclePartDetails,
                                          });
                                        }}
                                      />
                                    </address>
                                  </div>
                                </div>
                              )}
                              {getFieldPermission("quantity").show && (
                                <div className="col-sm-6">
                                  <div className="invoice-col">
                                    <b>Quantity:</b>{" "}
                                    <address>{item?.quantity || 0}</address>
                                  </div>
                                </div>
                              )}

                              {getFieldPermission("part_description").show && (
                                <div className="col-sm-6">
                                  <div className="invoice-col">
                                    <b> Description:</b>{" "}
                                    <address>
                                      {item?.part_description || "-"}
                                    </address>
                                  </div>
                                </div>
                              )}
                              {getFieldPermission("part_original_price")
                                .show && (
                                <div className="col-sm-6">
                                  <div className="invoice-col">
                                    <b> Original Price:</b>{" "}
                                    <address>
                                      € {item?.part_original_price || "0"}
                                    </address>
                                  </div>
                                </div>
                              )}
                              {getFieldPermission("part_cost_price").show && (
                                <div className="col-sm-6">
                                  <div className="invoice-col">
                                    <b> Cost Price:</b>{" "}
                                    <address>
                                      {" "}
                                      € {item?.part_cost_price || "0"}
                                    </address>
                                  </div>
                                </div>
                              )}
                              {getFieldPermission("part_price").show && (
                                <div className="col-sm-6">
                                  <div className="invoice-col">
                                    <b> Part Price:</b>{" "}
                                    <address>
                                      {" "}
                                      € {item?.part_price || "0"}
                                    </address>
                                  </div>
                                </div>
                              )}
                              {Number(item?.deposit_value) > 0 && (
                                <div className="col-sm-6">
                                  <div className="invoice-col">
                                    <b>{t("pi_deposit_value")}:</b>{" "}
                                    <address>€ {item?.deposit_value}</address>
                                  </div>
                                </div>
                              )}
                              {getFieldPermission("brand_id").show && (
                                <div className="col-sm-6">
                                  <div className="invoice-col">
                                    <b>
                                      {" "}
                                      {t("brand")}
                                      {t("name")}:
                                    </b>{" "}
                                    <address>{item.brand_name || "-"}</address>
                                  </div>
                                </div>
                              )}
                              {getFieldPermission("condition_id").show && (
                                <div className="col-sm-6">
                                  <div className="invoice-col">
                                    <b>Condition Name:</b>{" "}
                                    <address>
                                      {tConst(item?.condition_name, t) || "-"}
                                    </address>
                                  </div>
                                </div>
                              )}
                              {getFieldPermission("inventory_status").show && (
                                <div className="col-sm-6">
                                  <div className="invoice-col">
                                    <b>Inventory Status Name:</b>{" "}
                                    <address>
                                      {tConst(item?.inventory_status_name, t) || "-"}
                                    </address>
                                  </div>
                                </div>
                              )}
                              {getFieldPermission("parts_height").show && (
                                <div className="col-sm-6">
                                  <div className="invoice-col">
                                    <b>Height:</b>{" "}
                                    <address>
                                      {item?.parts_height || "-"}
                                    </address>
                                  </div>
                                </div>
                              )}
                              {getFieldPermission("parts_length").show && (
                                <div className="col-sm-6">
                                  <div className="invoice-col">
                                    <b>Length:</b>{" "}
                                    <address>
                                      {item?.parts_length || "-"}
                                    </address>
                                  </div>
                                </div>
                              )}
                              {getFieldPermission("parts_width").show && (
                                <div className="col-sm-6">
                                  <div className="invoice-col">
                                    <b>Width:</b>{" "}
                                    <address>
                                      {item?.parts_width || "-"}
                                    </address>
                                  </div>
                                </div>
                              )}
                              {getFieldPermission("parts_weight").show && (
                                <div className="col-sm-6">
                                  <div className="invoice-col">
                                    <b>Weight:</b>{" "}
                                    <address>
                                      {item?.parts_weight || "-"}
                                    </address>
                                  </div>
                                </div>
                              )}
                              {getFieldPermission("print_label").show && (
                                <div className="col-sm-6">
                                  <div className="invoice-col">
                                    <b>Print Label:</b>{" "}
                                    <address>
                                      {item?.print_label || "-"}
                                    </address>
                                  </div>
                                </div>
                              )}
                              {getFieldPermission("vehicle_type_id").show && (
                                <div className="col-sm-6">
                                  <div className="invoice-col">
                                    <b>Vehicle Type Name:</b>{" "}
                                    <address>
                                      {item?.vehicle_type_name || "-"}
                                    </address>
                                  </div>
                                </div>
                              )}

                              {getFieldPermission("vehicle_model").show && (
                                <div className="col-sm-6">
                                  <div className="invoice-col">
                                    <b>Modal Name:</b>{" "}
                                    <address>
                                      {item?.vehicle_model_name || "-"}
                                    </address>
                                  </div>
                                </div>
                              )}
                              {getFieldPermission("vehicle_year").show && (
                                <div className="col-sm-6">
                                  <div className="invoice-col">
                                    <b>Year:</b>{" "}
                                    <address>
                                      {item?.initial_year || "-"}
                                    </address>
                                  </div>
                                </div>
                              )}
                              {getFieldPermission("vehicle_make").show && (
                                <div className="col-sm-6">
                                  <div className="invoice-col">
                                    <b>Make Name:</b>{" "}
                                    <address>
                                      {item?.vehicle_make_name || "-"}
                                    </address>
                                  </div>
                                </div>
                              )}
                              {getFieldPermission("fuel_type_id").show && (
                                <div className="col-sm-6">
                                  <div className="invoice-col">
                                    <b>Fuel Name:</b>{" "}
                                    <address>
                                      {item?.fuel_type_name || "-"}
                                    </address>
                                  </div>
                                </div>
                              )}
                              {getFieldPermission("motorization").show && (
                                <div className="col-sm-6">
                                  <div className="invoice-col">
                                    <b>Motorization:</b>{" "}
                                    <address>
                                      {item?.motorization || "-"}
                                    </address>
                                  </div>
                                </div>
                              )}
                              {getFieldPermission("part_rating").show && (
                                <div className="col-sm-6">
                                  <div className="invoice-col">
                                    <b>Part Rating:</b>{" "}
                                    <address>
                                      <ReactStars
                                        count={5}
                                        value={item?.part_rating} // Show rating
                                        size={20}
                                        activeColor="#ffd700"
                                        edit={false} // Disable editing
                                      />
                                    </address>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                          {item?.parts_damage?.length > 0 && (
                            <>
                              {getFieldPermission("parts_damage").show && (
                                <>
                                  <div className="card-custom-heading">
                                    <p>Part Damage List</p>
                                  </div>
                                  <div className="card-body card-body-custom">
                                    <div className="vehicleThBg table-responsive">
                                      <table className="table table-bordered rounded-table table table-striped table-hover">
                                        <thead>
                                          <tr>
                                            <th className="col-form-label ml-2 Label-my form-label form-label">
                                              Damage Description
                                            </th>

                                            <th className="col-form-label ml-2 Label-my form-label form-label">
                                              Location Damage
                                            </th>

                                            <th className="col-form-label ml-2 Label-my form-label form-label">
                                              Type Damage
                                            </th>

                                            <th className="col-form-label ml-2 Label-my form-label form-label">
                                              Damage Rating
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {item?.parts_damage?.map((items) => {
                                            return (
                                              <>
                                                <tr>
                                                  {/* <td>{items?.part_rating}</td> */}
                                                  <td>
                                                    {items?.damage_description ||
                                                      "-"}
                                                  </td>
                                                  <td>
                                                    {tConst(items?.location_damage_name, t) ||
                                                      "-"}
                                                  </td>
                                                  <td>
                                                    {tConst(items?.type_damage_name, t) ||
                                                      "-"}
                                                  </td>
                                                  <td>
                                                    {items?.damage_rating ||
                                                      "-"}
                                                  </td>
                                                </tr>
                                              </>
                                            );
                                          })}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </>
                              )}
                            </>
                          )}

                          {item?.part_qty_list?.length > 0 && (
                            <>
                              <div className="card-custom-heading">
                                <p>Part Quantity List</p>
                              </div>
                              <div className="card-body card-body-custom">
                                <div className="vehicleThBg table-responsive">
                                  <table className="table table-bordered rounded-table table table-striped table-hover">
                                    <thead>
                                      <tr>
                                        {/* <th className="col-form-label ml-2 Label-my form-label form-label">
                                          Rating
                                        </th> */}
                                        <th className="col-form-label ml-2 Label-my form-label form-label">
                                          Location Name
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {item?.part_qty_list?.map((items) => {
                                        return (
                                          <>
                                            <tr>
                                              {/* <td>{items?.part_rating}</td> */}
                                              <td>
                                                {items?.location_name || "-"}
                                              </td>
                                            </tr>
                                          </>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </>
                          )}

                          {item?.parts_reference?.length > 0 && (
                            <>
                              {getFieldPermission("parts_reference").show && (
                                <>
                                  <div className="card-custom-heading">
                                    <p>Part Reference List</p>
                                  </div>
                                  <div className="card-body card-body-custom">
                                    <div className="vehicleThBg table-responsive">
                                      <table className="table table-bordered rounded-table table table-striped table-hover">
                                        <thead>
                                          <tr>
                                            <th className="col-form-label ml-2 Label-my form-label form-label">
                                              Condition Name
                                            </th>
                                            <th className="col-form-label ml-2 Label-my form-label form-label">
                                              Type Name
                                            </th>

                                            <th className="col-form-label ml-2 Label-my form-label form-label">
                                              Is Main
                                            </th>

                                            <th className="col-form-label ml-2 Label-my form-label form-label">
                                              Reference Code{" "}
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {item?.parts_reference?.map(
                                            (items) => {
                                              return (
                                                <>
                                                  <tr>
                                                    <td>
                                                      {tConst(items?.condition_name, t)}
                                                    </td>
                                                    <td>{tConst(items?.type_name, t)}</td>
                                                    <td>{items?.is_main}</td>
                                                    <td>
                                                      {items?.reference_code}
                                                    </td>
                                                  </tr>
                                                </>
                                              );
                                            }
                                          )}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </>
                              )}
                            </>
                          )}

                          {item?.parts_associate?.length > 0 && (
                            <>
                              {getFieldPermission("parts_associate").show && (
                                <>
                                  <div className="card-custom-heading">
                                    <p>Part Associate</p>
                                  </div>
                                  <div className="card-body card-body-custom">
                                    <div className="vehicleThBg table-responsive">
                                      <table className="table table-bordered rounded-table table table-striped table-hover">
                                        <thead>
                                          <tr>
                                            <th className="col-form-label ml-2 Label-my form-label form-label">
                                              Vehicle Type
                                            </th>
                                            <th className="col-form-label ml-2 Label-my form-label form-label">
                                              Year
                                            </th>
                                            <th className="col-form-label ml-2 Label-my form-label form-label">
                                              Make
                                            </th>

                                            <th className="col-form-label ml-2 Label-my form-label form-label">
                                              Modal
                                            </th>
                                            <th className="col-form-label ml-2 Label-my form-label form-label">
                                              Variant
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {item?.parts_associate?.map(
                                            (items) => {
                                              return (
                                                <>
                                                  <tr>
                                                    <td>
                                                      {items?.vehicle_type_name}
                                                    </td>
                                                    <td>
                                                      {items?.vehicle_year}
                                                    </td>
                                                    <td>{items?.make_name}</td>
                                                    <td>
                                                      {items?.model_id ===
                                                        "0" ||
                                                      items?.model_id === 0
                                                        ? "All"
                                                        : items?.model_name}
                                                    </td>
                                                    <td>
                                                      {items?.vehicle_variant ===
                                                        "0" ||
                                                      items?.vehicle_variant ===
                                                        0
                                                        ? "All"
                                                        : items?.variant_name ||
                                                          "All"}
                                                    </td>
                                                  </tr>
                                                </>
                                              );
                                            }
                                          )}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </>
                              )}
                            </>
                          )}

                          {item?.parts_assoicate_list?.length > 0 && (
                            <>
                              <div className="card-custom-heading">
                                <p>Part Associate List</p>
                              </div>
                              <div className="card-body card-body-custom">
                                <div className="vehicleThBg table-responsive">
                                  <table className="table table-bordered rounded-table table table-striped table-hover">
                                    <thead>
                                      <tr>
                                        <th className="col-form-label ml-2 Label-my form-label form-label">
                                          Part Name
                                        </th>
                                        <th className="col-form-label ml-2 Label-my form-label form-label">
                                          Modal Name
                                        </th>
                                        <th className="col-form-label ml-2 Label-my form-label form-label">
                                          Make Name
                                        </th>
                                        <th className="col-form-label ml-2 Label-my form-label form-label">
                                          {t("action")}
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {item?.parts_assoicate_list?.map(
                                        (items) => {
                                          return (
                                            <>
                                              <tr>
                                                <td>{items?.part_name}</td>

                                                <td>
                                                  {items?.vehicle_model_name}
                                                </td>
                                                <td>
                                                  {items?.vehicle_make_name}
                                                </td>

                                                <td>
                                                  <div
                                                    className="button-group"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                      gap: "10px",
                                                    }}
                                                  >
                                                    <div className="trash-btn">
                                                      <a
                                                        className="delete-btn"
                                                        onClick={(e) =>
                                                          onDeleteModalOpen(
                                                            e,
                                                            item
                                                          )
                                                        }
                                                        style={{
                                                          display: "flex",
                                                          alignItems: "center",
                                                        }}
                                                      >
                                                        <i className="bi bi-trash3"></i>
                                                      </a>
                                                    </div>
                                                    <a
                                                      className="edit-btn"
                                                      href="#"
                                                      style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                      }}
                                                      onClick={() =>
                                                        navigate(
                                                          `/part/details/main/${item.id}`,
                                                          { state: item }
                                                        )
                                                      }
                                                    >
                                                      <i className="bi bi-card-checklist"></i>
                                                    </a>
                                                  </div>
                                                </td>
                                              </tr>
                                            </>
                                          );
                                        }
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </>
                          )}
                          {item?.image_list?.length > 0 && (
                            <>
                              {getFieldPermission("parts_photos").show && (
                                <>
                                  <div className="card-custom-heading">
                                    <p>Part images</p>
                                  </div>

                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "end",
                                      marginTop: "-43px",
                                      marginRight: "7px",
                                    }}
                                  >
                                    <button
                                      type="button"
                                      className="btn btn-block btn-primary"
                                      style={{ width: "148px" }}
                                      onClick={handleZipPartImageDownload}
                                      disabled={isDownloading}
                                    >
                                      {isDownloading ? (
                                        <div
                                          className="spinner-border spinner-border-sm"
                                          role="status"
                                        >
                                          <span className="sr-only">
                                            Loading...
                                          </span>
                                        </div>
                                      ) : (
                                        <>
                                          Download Zip{" "}
                                          <i className="bi bi-file-earmark-zip"></i>
                                        </>
                                      )}
                                    </button>
                                  </div>

                                  {/* ---------------- PHOTO VIEW PROVIDER ---------------- */}
                                  <PhotoProvider
                                    visible={viewerOpen}
                                    onVisibleChange={(v) => setViewerOpen(v)}
                                    current={viewerIndex}
                                    onIndexChange={(i) => setViewerIndex(i)}
                                  >
                                    <div className="card-body card-body-custom">
                                      <div className="row justify-content-start">
                                        {item?.image_list?.map(
                                          (image, index) => (
                                            <div
                                              key={index}
                                              className="col-sm-3"
                                            >
                                              <div
                                                className="column-img"
                                                style={{ position: "relative" }}
                                              >
                                                {/* Image (NOT clickable) */}
                                                <PhotoView
                                                  src={image?.image_url}
                                                >
                                                  <img
                                                    src={image?.image_url}
                                                    alt=""
                                                    style={{
                                                      width: "100%",
                                                      height: "160px",
                                                      objectFit: "cover",
                                                      borderRadius: "6px",
                                                    }}
                                                  />
                                                </PhotoView>
                                              </div>
                                            </div>
                                          )
                                        )}
                                      </div>
                                    </div>
                                  </PhotoProvider>
                                </>
                              )}
                            </>
                          )}

                          {item?.part_attribute?.length > 0 && (
                            <>
                              {getFieldPermission("parts_attribute").show && (
                                <>
                                  <div className="card-custom-heading">
                                    <p>{t("part_attribute_list")}</p>
                                  </div>
                                  <div className="card-body card-body-custom">
                                    <div className="vehicleThBg table-responsive">
                                      <table className="table table-bordered rounded-table table table-striped table-hover">
                                        <thead>
                                          <tr>
                                            <th className="col-form-label ml-2 Label-my form-label form-label">
                                              {t("label_name")}
                                            </th>

                                            <th className="col-form-label ml-2 Label-my form-label form-label">
                                              {t("attribute_value")}
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {item?.part_attribute
                                            ?.filter(
                                              (items) => items.is_view === 1
                                            )
                                            ?.map((items, index) => (
                                              <tr key={index}>
                                                <td>
                                                  {items?.label_name || "-"}
                                                </td>
                                                <td>
                                                  {items?.attribute_value ||
                                                    "-"}
                                                </td>
                                              </tr>
                                            ))}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </>
                              )}
                            </>
                          )}

                          {item?.parts_checklist?.length > 0 && (
                            <>
                              {getFieldPermission("parts_checklist").show && (
                                <>
                                  <div className="card-custom-heading">
                                    <p>{t("part_check_list")}</p>
                                  </div>
                                  <div className="card-body card-body-custom">
                                    <div className="vehicleThBg table-responsive">
                                      <table className="table table-bordered rounded-table table table-striped table-hover">
                                        <thead>
                                          <tr>
                                            <th className="col-form-label ml-2 Label-my form-label form-label">
                                              {t("name")}
                                            </th>

                                            <th className="col-form-label ml-2 Label-my form-label form-label">
                                              {t("description")}
                                            </th>
                                            <th className="col-form-label ml-2 Label-my form-label form-label">
                                              {t("check_list_status_name")}
                                            </th>
                                            <th className="col-form-label ml-2 Label-my form-label form-label">
                                              {t("is_default")}
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {item?.parts_checklist?.map(
                                            (items, index) => (
                                              <tr key={index}>
                                                <td>{items?.name || "-"}</td>
                                                <td>
                                                  {items?.description || "-"}
                                                </td>
                                                <td>
                                                  {items?.check_list_status_name ||
                                                    "-"}
                                                </td>
                                                <td>
                                                  {items?.is_default === 1
                                                    ? "Yes"
                                                    : "No" || "-"}
                                                </td>
                                              </tr>
                                            )
                                          )}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </>
                              )}
                            </>
                          )}

                          {vehicleVideoDetails?.length > 0 && (
                            <>
                              {getFieldPermission("parts_videos").show && (
                                <>
                                  <div className="card-custom-heading">
                                    <p>Part Video</p>

                                    <div
                                      style={{
                                        display: "flex",

                                        justifyContent: "end",
                                        marginTop: "-22px",
                                      }}
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-block btn-primary"
                                        style={{ width: "148px" }}
                                        onClick={handleZipPartVideoDownload}
                                        disabled={isLoading}
                                      >
                                        {isLoading ? (
                                          <div
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                          >
                                            <span className="sr-only">
                                              Loading...
                                            </span>
                                          </div>
                                        ) : (
                                          <>
                                            Download Zip{" "}
                                            <i className="bi bi-file-earmark-zip"></i>
                                          </>
                                        )}
                                      </button>
                                    </div>
                                  </div>

                                  <div className="card-body card-body-custom">
                                    <div className="row justify-content-start">
                                      {vehicleVideoDetails?.map((items) => {
                                        return (
                                          <>
                                            <div className="col-sm-3">
                                              <div className="column-img">
                                                <video
                                                  src={items.video_url}
                                                  width="200"
                                                  controls
                                                  style={{
                                                    borderRadius: "5px",
                                                    margin: "5px",
                                                  }}
                                                >
                                                  Your browser does not support
                                                  the video tag.
                                                </video>
                                              </div>
                                            </div>
                                          </>
                                        );
                                      })}
                                    </div>
                                  </div>
                                </>
                              )}
                            </>
                          )}

                          {vehicleImageDetails?.length > 0 && (
                            <>
                              <div className="card-custom-heading">
                                <p>Part Damage Image List</p>
                              </div>
                              <div className="card-body card-body-custom">
                                <div className="vehicleThBg table-responsive">
                                  <table className="table table-bordered rounded-table table table-striped table-hover">
                                    <tbody>
                                      {vehicleImageDetails
                                        ?.filter(
                                          (item) => item.damage_list.length > 0
                                        )
                                        .map((item, index) => (
                                          <React.Fragment key={index}>
                                            <tr>
                                              <td>
                                                <div className="col-sm-3">
                                                  <div className="column-img">
                                                    <img
                                                      src={item?.image_url}
                                                      alt=""
                                                    />
                                                  </div>
                                                </div>
                                              </td>
                                            </tr>

                                            {item?.damage_list?.map(
                                              (damage, damageIndex) => (
                                                <tr key={damageIndex}>
                                                  <td
                                                    colSpan="2"
                                                    style={{
                                                      paddingLeft: "50px",
                                                    }}
                                                  >
                                                    <strong>
                                                      Damage Description:
                                                    </strong>{" "}
                                                    {damage.damage_description}{" "}
                                                    <br />
                                                  </td>
                                                </tr>
                                              )
                                            )}
                                          </React.Fragment>
                                        ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </>
                          )}

                          {vehicleVideoDetails &&
                            vehicleVideoDetails.some(
                              (item) => item.damage_list.length > 0
                            ) && (
                              <>
                                <div className="card-custom-heading">
                                  <p>Part Damage Video List</p>
                                </div>
                                <div className="card-body card-body-custom">
                                  <div className="vehicleThBg table-responsive">
                                    <table className="table table-bordered rounded-table table table-striped table-hover">
                                      <tbody>
                                        {vehicleVideoDetails
                                          ?.filter(
                                            (item) =>
                                              item.damage_list.length > 0
                                          )
                                          .map((item, index) => (
                                            <React.Fragment key={index}>
                                              <tr>
                                                <td>
                                                  <div className="col-sm-3">
                                                    <div className="column-img">
                                                      <video
                                                        src={item.video_url}
                                                        width="200"
                                                        controls
                                                        style={{
                                                          borderRadius: "5px",
                                                          margin: "5px",
                                                        }}
                                                      >
                                                        Your browser does not
                                                        support the video tag.
                                                      </video>
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>

                                              {item?.damage_list?.map(
                                                (damage, damageIndex) => (
                                                  <tr key={damageIndex}>
                                                    <td
                                                      colSpan="2"
                                                      style={{
                                                        paddingLeft: "50px",
                                                      }}
                                                    >
                                                      <strong>
                                                        Damage Description:
                                                      </strong>{" "}
                                                      {
                                                        damage.damage_description
                                                      }{" "}
                                                      <br />
                                                    </td>
                                                  </tr>
                                                )
                                              )}
                                            </React.Fragment>
                                          ))}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              );
            })
          ) : (
            <p>No details Found</p>
          )}
        </section>
      </div>

      <Modal isOpen={delModal}>
        <ModalHeader>{`Delete Part`}</ModalHeader>
        <ModalBody>
          <p className={`mb-0`}>{`Are you sure you want to delete?`}</p>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={onDeleteModalClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            Close <i className="bi bi-x-lg"></i>
          </button>

          <button
            type="button"
            className="btn btn-block bg-red"
            style={{ width: "153px" }}
            onClick={onDestroyPartType}
          >
            Delete From Inventory <i className="bi bi-trash3"></i>
          </button>

          <button
            type="button"
            className="btn btn-block bg-red"
            style={{ width: "197px" }}
            onClick={onDestroyassociatePartType}
          >
            Delete from Associate Part <i className="bi bi-trash3"></i>
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modifyReplicateParts} size="xl">
        <ModalHeader>{`Replicate Parts`}</ModalHeader>

        <Form method={`post`} onSubmit={handleSubmitReplicateParts}>
          <ModalBody>
            <div className="row">
              <table className="fuelTable">
                <tbody className="row">
                  <tr className="col-md-6">
                    <td>Part Name</td>
                    <td>:</td>
                    <td>{partAddDetails?.namePartPT}</td>
                  </tr>

                  <tr className="col-md-6">
                    <td>Year</td>
                    <td>:</td>
                    <td>{partAddDetails?.vehicle_year}</td>
                  </tr>

                  <tr className="col-md-6">
                    <td>Make</td>
                    <td>:</td>
                    <td>{partAddDetails?.vehicle_make_name}</td>
                  </tr>

                  <tr className="col-md-6">
                    <td>Model</td>
                    <td>:</td>
                    <td>{partAddDetails?.vehicle_model_name}</td>
                  </tr>

                  <tr className="col-md-6">
                    <td>Variant</td>
                    <td>:</td>
                    <td>{partAddDetails?.vehicle_variant_name}</td>
                  </tr>

                  <tr className="col-md-6"></tr>
                </tbody>
              </table>
            </div>

            <div className="row">
              <div className="col-lg-6">
                <div className="input-div">
                  <div className="form-check">
                    <input
                      className="my-checkbox-1 form-check-input"
                      type="checkbox"
                      checked={
                        replicatePartsData.copy_compatiable_vehicles === 1
                      }
                      onChange={handleCheckboxChangeCompatibleVehicle}
                    />
                    <label className="form-check-label pl-6">
                      Copy Compatible Vehicles (
                      {partAddDetails?.parts_associate?.length ?? 0})
                    </label>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="input-div">
                  <div className="form-check">
                    <input
                      className="my-checkbox-1 form-check-input"
                      type="checkbox"
                      checked={replicatePartsData.copy_photo === 1}
                      onChange={handleCheckboxChangeCopyPhoto}
                    />
                    <label className="form-check-label pl-6">
                      Copy Photo ({partAddDetails?.image_list?.length ?? 0})
                    </label>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="input-div">
                  <div className="form-check">
                    <input
                      className="my-checkbox-1 form-check-input"
                      type="checkbox"
                      checked={replicatePartsData.copy_video === 1}
                      onChange={handleCheckboxChangeCopyVideo}
                    />
                    <label className="form-check-label pl-6">
                      Copy Video ({partAddDetails?.video_list?.length ?? 0})
                    </label>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="input-div">
                  <div className="form-check">
                    <input
                      className="my-checkbox-1 form-check-input"
                      type="checkbox"
                      checked={replicatePartsData.copy_reference === 1}
                      onChange={handleCheckboxChangeCopyRef}
                    />
                    <label className="form-check-label pl-6">
                      Copy Reference (
                      {partAddDetails?.parts_reference?.length ?? 0})
                    </label>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="input-div">
                  <div className="form-check">
                    <input
                      className="my-checkbox-1 form-check-input"
                      type="checkbox"
                      checked={replicatePartsData.copy_damage === 1}
                      onChange={handleCheckboxChangeCopyDamage}
                    />
                    <label className="form-check-label pl-6">
                      Copy Damage ({partAddDetails?.parts_damage?.length ?? 0})
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6"></div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              onClick={handleReplicateClose}
              style={{ width: "100px", marginTop: "10px" }}
            >
              Close <i className="bi bi-x-lg"></i>
            </button>
            {loading ? (
              <button
                type="submit"
                className="btn btn-block btn-primary"
                style={{ width: "100px", marginTop: "10px" }}
              >
                loading...
              </button>
            ) : (
              <button
                type="submit"
                className="btn btn-block btn-primary"
                style={{ width: "100px", marginTop: "10px" }}
              >
                Submit <i className="bi bi-check2"></i>
              </button>
            )}
          </ModalFooter>
        </Form>
      </Modal>

      <Modal isOpen={modifyVehiclereplica}>
        <ModalHeader>Vehicle Part</ModalHeader>
        <ModalBody>
          <p
            className={`mb-0`}
          >{`Part is already available in vehicle do you still wants to replicate a part?`}</p>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleVehiclereplicaOpen}
            style={{ width: "100px", marginTop: "10px" }}
          >
            No <i className="bi bi-x-lg"></i>
          </button>

          <button
            type="button"
            className="btn btn-block btn-primary"
            style={{ width: "100px" }}
            onClick={handleSubmitVehicleReplicateParts}
          >
            Yes <i className="bi bi-check2"></i>
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modifyReservesParts} size="lg">
        <ModalHeader>Reserves Part</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-lg-6 addPartField">
              <label className="partsLabel">Reserves Name</label>

              <Select
                className="my-select-v"
                options={reservesSerachList}
                value={
                  reservesSerachList.find(
                    (item) => item.value == reservesData.reservation_id
                  ) || null
                }
                onChange={(selectedOption) =>
                  setReservesData({
                    ...reservesData,
                    reservation_id: selectedOption ? selectedOption.value : "",
                  })
                }
                isSearchable={true}
                isClearable={true}
                placeholder={"Select Reserves"}
              />
            </div>

            <div className="col-lg-6 addPartField"></div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div
                className="row"
                style={{
                  overflowX: "auto",
                  maxHeight: "250px",
                }}
              >
                <div className="card-body">
                  <div className="vehicleThBg table-responsive table-responsive-vehicle">
                    <table className="table table-bordered rounded-table table table-striped table-hover">
                      <thead>
                        <tr>
                          <th
                            className="col-form-label ml-2 Label-my form-label"
                            style={{ width: "10%" }}
                          ></th>
                          <th
                            className="col-form-label ml-2 Label-my form-label"
                            style={{ width: "10%" }}
                          >
                            Quantity
                          </th>

                          <th
                            className="col-form-label ml-2 Label-my form-label"
                            style={{ width: "10%" }}
                          >
                            Entity
                          </th>
                          <th
                            className="col-form-label ml-2 Label-my form-label"
                            style={{ width: "10%" }}
                          >
                            Price
                          </th>

                          <th
                            className="col-form-label ml-2 Label-my form-label"
                            style={{ width: "10%" }}
                          >
                            Notes
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {reservesPenList[0]?.part_qty_list?.length > 0 ? (
                          reservesPenList[0]?.part_qty_list?.map(
                            (part, index) => (
                              <tr style={{ cursor: "pointer" }} key={index}>
                                <td>
                                  <input
                                    type="checkbox"
                                    className="my-checkbox-1 form-check-input"
                                    checked={selectedParts.some(
                                      (item) => item.id === part.id
                                    )}
                                    onChange={() =>
                                      handleCheckboxChange(
                                        part.parts_id,
                                        part.id
                                      )
                                    }
                                    style={{ marginLeft: "100px" }}
                                  />
                                </td>
                                <td>{part.qty}</td>

                                <td>
                                  <select
                                    className="form-select"
                                    value={
                                      selectedEntitiesRes[part.id] ||
                                      part.location_ids ||
                                      ""
                                    }
                                    onChange={(e) =>
                                      handleSelectChangeRes(e, part)
                                    }
                                  >
                                    <option value="" disabled>
                                      Select
                                    </option>
                                    {renderOptions(entityList)}
                                  </select>
                                </td>
                                <td>
                                  <div>
                                    <label>
                                      Price 1: {PartsDataList.part_price}
                                    </label>
                                  </div>

                                  <div>
                                    <label>
                                      Price 2:{" "}
                                      {PartsDataList.part_original_price}
                                    </label>
                                  </div>

                                  <div>
                                    <label>
                                      Price 2: {PartsDataList.part_cost_price}
                                    </label>
                                  </div>

                                  <div>
                                    <label>
                                      Manual:
                                      <input
                                        type="number"
                                        value={selectedPrices[part.id] || ""}
                                        onChange={(e) =>
                                          handleManualInput(
                                            part.id,
                                            e.target.value
                                          )
                                        }
                                        placeholder={t("pi_enter_manual_price")}
                                        style={{
                                          marginLeft: "10px",
                                          width: "100px",
                                        }}
                                      />
                                    </label>
                                  </div>
                                </td>

                                <td>
                                  <div className="input-div">
                                    <textarea
                                      className="form-control"
                                      value={
                                        resOrderData.reservation_order_notes[
                                          part.id
                                        ] || ""
                                      }
                                      onChange={(e) =>
                                        setResOrderData((prev) => ({
                                          ...prev,
                                          reservation_order_notes: {
                                            ...prev.reservation_order_notes,
                                            [part.id]: e.target.value,
                                          },
                                        }))
                                      }
                                      name={`reservation_order_notes_${part.id}`}
                                      placeholder={t("notes")}
                                      rows={3}
                                    />
                                  </div>
                                </td>
                              </tr>
                            )
                          )
                        ) : (
                          <tr>
                            <td colSpan="5" style={{ textAlign: "center" }}>
                              No data found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleReservesClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            No <i className="bi bi-x-lg"></i>
          </button>

          <button
            type="button"
            className="btn btn-block btn-primary"
            style={{ width: "100px" }}
            onClick={handleSubmitReserves}
          >
            Yes <i className="bi bi-check2"></i>
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={delRestoreModa}>
        <ModalHeader>{`Restore Inventory Part`}</ModalHeader>
        <ModalBody>
          <p
            className={`mb-0`}
          >{`Are you sure you want to restore this inventory part?`}</p>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            disabled={isDelButtonLoad}
            onClick={onDeleteRestoreModalClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            Close <i className="bi bi-x-lg"></i>
          </button>

          <>
            <button
              type="button"
              className="btn btn-block bg-red"
              style={{ width: "100px" }}
              onClick={onDestroyPartInventory}
            >
              Restore <i className="bi bi-arrow-repeat"></i>
            </button>
          </>

          {isDelButtonLoad && (
            <button
              color="secondary"
              type={`button`}
              disabled={true}
              className={`btn-square`}
            >
              <i className="fa fa-circle-o-notch fa-spin"></i> {`Loading...`}
            </button>
          )}
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default PartdetailsInventory;
